module.exports = __webpack_public_path__ + "assets_1789874507493/img/logo_v1.dc05f9dd.png";